import { Card, Col, Row, Table } from 'react-bootstrap'
import { Pencil } from 'lucide-react'
import RowEmpty from '../../../../components/atoms/RowEmpty'
import { cardStyle, tableHeaderStyle } from './DcDetailStyles'

const DcListItems = ({ detail, items, handleUpdateItem }) => {
  return (
    <Card style={cardStyle}>
      <Row className="mb-3">
        <Col
          md={12}
          className="d-flex justify-content-between align-items-center"
        >
          <h5
            className="text-secondary mb-0"
            style={{ fontSize: '1rem', fontWeight: 'bold' }}
          >
            LIST ITEMS
          </h5>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Table
            hover
            responsive
            className="mb-0"
            size="sm"
            style={{ fontSize: '12px' }}
          >
            <thead>
              <tr>
                <th style={tableHeaderStyle} className="p-2 align-middle">
                  No
                </th>
                <th style={tableHeaderStyle} className="p-2 align-middle">
                  Item
                </th>
                <th
                  style={tableHeaderStyle}
                  className="p-2 text-end align-middle"
                >
                  Batch
                </th>
                <th
                  style={tableHeaderStyle}
                  className="p-2 text-end align-middle"
                >
                  Base UOM Qty
                </th>
                <th
                  style={tableHeaderStyle}
                  className="p-2 text-end align-middle"
                >
                  Confirmed Qty
                </th>
                <th
                  style={tableHeaderStyle}
                  className="p-2 text-end align-middle"
                >
                  Difference
                </th>
                <th
                  style={tableHeaderStyle}
                  className="p-2 text-end align-middle"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {items.length > 0 ? (
                items.map((valueDetail, index) => (
                  <tr key={index}>
                    <td className="p-2 align-middle">{index + 1}</td>
                    <td className="p-2 align-middle">
                      {valueDetail?.item || '-'}
                    </td>
                    <td className="p-2 text-end align-middle">
                      {valueDetail?.batch || '-'}
                    </td>
                    <td className="p-2 text-end align-middle">
                      {valueDetail?.total_qty || '-'}
                    </td>
                    <td className="p-2 text-end align-middle">
                      {valueDetail?.confirmed_qty || '-'}
                    </td>
                    <td
                      className="p-2 text-end align-middle"
                      style={{ backgroundColor: '#C9CACD' }}
                    >
                      {valueDetail?.difference_qty || '0'}{' '}
                      {valueDetail?.difference_uom || ''}
                    </td>
                    <td className="p-2 text-end align-middle">
                      <button
                        type="button"
                        className="btn btn-secondary ml-2"
                        onClick={() => handleUpdateItem(valueDetail)}
                      >
                        <Pencil size={14} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <RowEmpty colSpan={7} />
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Card>
  )
}

export default DcListItems
